import { render, staticRenderFns } from "./WorkIconCamera.vue?vue&type=template&id=49c11520"
import script from "./WorkIconCamera.vue?vue&type=script&lang=js"
export * from "./WorkIconCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports